import { useState } from "react";
import { Camera, CheckCircle, X, Barcode } from "@phosphor-icons/react";
import { photoUrl } from "./walkApi";
import { RadarMark } from "./FieldRadarLogo";

const FIELDS = [["brand", "Brand", "e.g. Whirlpool"], ["model", "Model", "e.g. WRT518SZFM"], ["serial", "Serial", ""], ["color", "Color", "White / Stainless / Black"]];

export default function NameplateSheet({ item, roomName, existing, onSave, onClose, onPhoto }) {
  const [f, setF] = useState({ brand: "", model: "", serial: "", color: "", fuel: "", ...(existing || {}) });
  const [photo, setPhoto] = useState(existing?.photo_path || null);
  const [saving, setSaving] = useState(false);
  const showFuel = /range|heat|water/i.test(item);
  const save = async () => {
    setSaving(true);
    try { await onSave({ ...f, photo_path: photo }); onClose(); } finally { setSaving(false); }
  };
  return (
    <div className="fixed inset-0 z-40 flex flex-col justify-end bg-black/60" data-testid="nameplate-sheet">
      <div className="bg-white rounded-t-3xl p-5 pb-8 max-h-[92vh] overflow-y-auto">
        <div className="mx-auto w-14 h-1.5 rounded-full bg-slate-300 mb-4"/>
        <div className="flex items-start justify-between">
          <div>
            <div className="text-2xl font-black text-[#0b1c2d] flex items-center gap-2"><Barcode size={26} className="text-teal-600"/> {item} nameplate</div>
            <div className="text-sm text-slate-500">{roomName} · saved on the unit's assets</div>
          </div>
          <button onClick={onClose} className="w-10 h-10 -mr-2 flex items-center justify-center" data-testid="nameplate-close"><X size={22}/></button>
        </div>

        <button onClick={async () => { const p = await onPhoto(); if (p) setPhoto(p.path); }} data-testid="nameplate-photo"
          className="mt-4 w-full h-32 rounded-2xl border-2 border-dashed border-slate-300 flex items-center justify-center text-slate-500 overflow-hidden relative">
          {photo ? <img src={photoUrl(photo)} alt="" className="absolute inset-0 w-full h-full object-cover"/> : null}
          <div className={`relative flex flex-col items-center gap-1 ${photo ? "bg-black/50 text-white px-3 py-1 rounded-lg" : ""}`}>
            <Camera size={28} className={photo ? "text-white" : "text-teal-600"}/>
            <span className="text-sm font-bold">{photo ? "Retake sticker photo" : "Photo the sticker (inside the door or on the back)"}</span>
          </div>
        </button>

        <div className="mt-4 grid grid-cols-1 gap-3">
          {FIELDS.map(([k, label, ph]) => (
            <label key={k} className="block">
              <span className="text-[11px] font-black uppercase tracking-widest text-slate-500">{label}</span>
              <input value={f[k] || ""} onChange={e => setF(s => ({ ...s, [k]: e.target.value }))} placeholder={ph} data-testid={`nameplate-${k}`}
                autoCapitalize="characters" className="mt-1 w-full h-12 px-3 rounded-xl border-2 border-slate-300 font-bold text-[#0b1c2d]"/>
            </label>
          ))}
          {showFuel && (
            <div>
              <span className="text-[11px] font-black uppercase tracking-widest text-slate-500">Fuel</span>
              <div className="mt-1 grid grid-cols-2 gap-2">
                {["gas", "electric"].map(v => (
                  <button key={v} onClick={() => setF(s => ({ ...s, fuel: s.fuel === v ? "" : v }))} data-testid={`nameplate-fuel-${v}`}
                    className={`h-12 rounded-xl border-2 font-black capitalize ${f.fuel === v ? "bg-teal-600 border-teal-600 text-white" : "border-slate-300 text-slate-800"}`}>{v}</button>
                ))}
              </div>
            </div>
          )}
        </div>

        <button onClick={save} disabled={saving} data-testid="nameplate-save"
          className="mt-5 w-full h-14 rounded-2xl bg-teal-600 disabled:bg-slate-300 text-white font-black text-lg flex items-center justify-center gap-2">
          <CheckCircle weight="fill" size={24}/> Save nameplate
        </button>
        <div className="mt-3 flex items-center justify-center gap-2 text-xs text-slate-500"><RadarMark size={16}/> Field Radar keeps this on the unit's asset list.</div>
      </div>
    </div>
  );
}
